import { render, staticRenderFns } from "./_type.vue?vue&type=template&id=c5621612&scoped=true&"
import script from "./_type.vue?vue&type=script&lang=js&"
export * from "./_type.vue?vue&type=script&lang=js&"
import style0 from "./_type.vue?vue&type=style&index=0&id=c5621612&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5621612",
  null
  
)

export default component.exports